import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { useAccessibilitySettings } from './hooks/useAccessibilitySettings';
import { HomePage } from './pages/HomePage';
import { BlogPage } from './pages/BlogPage';
import { AdoptPage } from './pages/AdoptPage';
import { PostPage } from './pages/PostPage';
import { FeaturedPets } from './components/FeaturedPets';
import { SupportPage } from './pages/SupportPage';
import { PetPage } from './pages/PetPage';
import { ContactPage } from './pages/ContactPage';
import { AccessibilityDeclarationPage } from './pages/AccessibilityDeclarationPage';
import { TaxDonationPage } from './pages/TaxDonationPage';
import { FosterHomePage } from './pages/FosterHomePage';
import { VirtualAdoptionPage } from './pages/VirtualAdoptionPage';
import { StoryPage } from './pages/StoryPage';
import { VolunteerPage } from './pages/VolunteerPage';
import { AboutPage } from './pages/AboutPage';
import { SitemapPage } from './pages/SitemapPage';
import { StatutePage } from './pages/StatutePage';
import { AdoptionStoriesPage } from './pages/AdoptionStoriesPage';
import { DonationPage } from './pages/DonationPage';
import { FinancialReportsPage } from './pages/FinancialReportsPage';
import { FundingPage } from './pages/FundingPage';
import { RainbowBridgePage } from './pages/RainbowBridgePage';
import { TermsPage } from './pages/TermsPage';
import { CookiesPolicyPage } from './pages/CookiesPolicyPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { SanityPetRedirect } from './components/SanityPetRedirect';
import { SanityStructureRedirect } from './components/SanityStructureRedirect';
// import { PaymentTestPage } from './pages/PaymentTestPage';
import { ThankYouPage } from './pages/ThankYouPage';
import { NewsletterSuccessPage } from './pages/NewsletterSuccessPage';
import { NotFoundPage } from './pages/NotFoundPage';

function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default function App() {
  const { fontSize, adjustFontSize } = useAccessibilitySettings();

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Layout fontSize={fontSize} adjustFontSize={adjustFontSize}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/aktualnosci" element={<BlogPage />} />
          <Route path="/aktualnosci/:slug" element={<PostPage />} />
          <Route path="/adoptuj" element={<AdoptPage />} />
          <Route path="/zwierzeta" element={<FeaturedPets />} />
          <Route path="/wsparcie" element={<SupportPage />} />
          <Route path="/zwierze/:slug" element={<PetPage />} />
          {/* Sanity Studio URL redirects */}
          <Route path="/structure/pet;:id" element={<SanityPetRedirect />} />
          <Route path="/structure/:structureType;:id" element={<SanityStructureRedirect />} />
          <Route path="/kontakt" element={<ContactPage />} />
          <Route path="/przekaz-podatek" element={<TaxDonationPage />} />
          <Route path="/dom-tymczasowy" element={<FosterHomePage />} />
          <Route path="/historie-adopcyjne" element={<AdoptionStoriesPage />} />
          <Route path="/wirtualna-adopcja" element={<VirtualAdoptionPage />} />
          <Route path="/historia/:id" element={<StoryPage />} />
          <Route path="/deklaracja-dostepnosci" element={<AccessibilityDeclarationPage />} />
          <Route path="/wolontariat" element={<VolunteerPage />} />
          <Route path="/o-nas" element={<AboutPage />} />
          <Route path="/statut" element={<StatutePage />} />
          <Route path="/sprawozdania" element={<FinancialReportsPage />} />
          <Route path="/dofinansowania" element={<FundingPage />} />
          <Route path="/za-teczowym-mostem" element={<RainbowBridgePage />} />
          <Route path="/mapa-strony" element={<SitemapPage />} />
          <Route path="/wplata-jednorazowa" element={<DonationPage />} />
          {/* <Route path="/test-payment" element={<PaymentTestPage />} /> */}
          <Route path="/dziekujemy" element={<ThankYouPage />} />
          <Route path="/podziekowanie" element={<NewsletterSuccessPage />} />
          <Route path="/polityka-prywatnosci" element={<PrivacyPolicyPage />} />
          <Route path="/polityka-cookies" element={<CookiesPolicyPage />} />
          <Route path="/regulamin" element={<TermsPage />} />
          {/* Catch-all route for non-existent pages - redirects to homepage */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}